//
// AHT Weight Management — Orlistat (Xenical®) Initial Supply Pathway
// Source: AHT_Orlistat_Clinical_Pathway.docx v1.0
//
// QUANTITIES ARE PRE-VERIFIED LOOKUPS. DO NOT CALCULATE.
// This pathway covers initial supply only: 84 × orlistat 120mg capsules (28-day supply).

import type { Pathway } from "../../types/pathway.types";
import {
  PGD_FRESH_CHECKS,
  orlistatScreeningDownstreamNodes,
  orlistatScreeningOutcomes,
} from "./_shared/orlistat-screening-downstream";

// ─────────────────────────────────────────────────────────────────────────────
// Node IDs
// ─────────────────────────────────────────────────────────────────────────────


// ─────────────────────────────────────────────────────────────────────────────
// Pathway
// ─────────────────────────────────────────────────────────────────────────────

export const ahtWtOrlistatInitialPathway: Pathway = {
  id: "aht-wt-orlistat-initial",
  name: "Orlistat (Xenical®) — Initial Supply",
  population: "Adults attending face-to-face for initial supply",
  pgdRefs: ["pgd-aht-wt-orlistat"],
  demographicConfiguration: { bannerFields: [] },
  entryNode: PGD_FRESH_CHECKS,

  nodes: [
    // ─────────────────────────────────────────────────────────────────────────
    // Steps 1–4 — shared screening downstream (PGD fresh checks, interaction
    // checks, cautions review, supply attestation). Single source of truth.
    // ─────────────────────────────────────────────────────────────────────────
    ...orlistatScreeningDownstreamNodes,
  ],

  outcomes: orlistatScreeningOutcomes,
};
